<style lang="less">
.itembank{
	width: 100%;
	.vue-item{
		height: 72px;
	}
	&.active{
		.vue-item-submark__subject{
			color: #000;
		}
	}
}
</style>

<template>
	<!-- Main itembank -->
	<div :class="bank.index == -1 ? 'itembank' : 'itembank active' ">
		<item
			mark-subject="银行卡"
			mark-subject-attach=""
			:submark-subject="bank.index == -1 ? '请选择' : bank.data[bank.index].text"
			submark-subject-attach=""
			ico-type="select"
			@click.native="choose_bank"
		></item>

		<poplist :show="bank.isShow" :list="bank.data" v-on:impress="bank_pop" :selectindex="bank.index"></poplist>

	</div>

</template>

<script>
	import item from '@flyme/jr/flyme7/component/item/vue-item.vue';
	import android from '@flyme/jr/js/android.js';
	import poplist from '@flyme/jr/flyme7/component/pop-list/pop-list.vue';

	import axios from '../axios.js';
	import apis from '../apis.js';
	import config from '../config.js';

	export default {
		data: function () {
			return {
				userinfo: {},
				bank: {
					index: -1,
					isShow: false,
					data: [],
				}
			};
		},
		components: {
			item,
			poplist
		},
		created: function () {
			this.getUserInfo();
		},
		methods: {
			getUserInfo: function () {
				let _this = this;
				android('getUserInfo', {}, (d) => {
					_this.userinfo = d;
					this.get_banks_data();
				});
			},
			get_banks_data: function() {
				let _this = this;
				axios.post(apis.bank_list, {
					user_id: this.userinfo.userId,
					partner_id: config.partner_id,
					partner_cp_type: config.partner_cp_type
				}).then(function(d) {
					console.log('bank_list', d);
					var bank_data = [];
					for( var i in d.value.rows){
						bank_data.push({
							"id": d.value.rows[i].bankAccNoIndex,
							"text": d.value.rows[i].bankName + ' ' + d.value.rows[i].bankNoLast4,
							"raw": d.value.rows[i]
						});
					}
					bank_data.push({
						"id": 0,
						"text": "添加银行卡"
					});
					_this.bank.data = bank_data;
					_this.sendInitSelect();
				});
			},
			bank_pop: function(index) {
				this.bank.isShow = false;
				if (this.bank.data[index].id === 0) {
					this.add_bank();
				} else {
					this.bank.index = index;
					this.$emit('bankSelect', this.bank.data[this.bank.index]);
				}
			},
			add_bank: function () {
				let _this = this;
				let params = {
					'from': 'bank_select',
					'partner_id': config.partner_id,
					'partner_cp_type': config.partner_cp_type,
					'business': 'ecash',
				};
				let param_array = [];
				for( var i in params) {
					param_array.push(i+'='+params[i]);
				}
				android('startPageWithCallback', {
					// url: 'https://jr-res.meizu.com/resources/jr/flyme7/html/financial/bindBank.html?' + param_array.join('&'),
					url: 'https://jr-res.meizu.com/resources/jr/flyme7/html/financial/bindBank.html?from=cardlist&business=other',
					start_type: 1,
					data: '',
					display: {
						title: '添加银行卡'
					}
				}, function () {
					_this.get_banks_data();
				});
			},
			choose_bank: function() {
				this.bank.isShow = true;
			},
			sendInitSelect: function () {
				this.bank.index = 0;
				this.$emit('bankSelect', this.bank.data[this.bank.index]);
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/bankSelect.vue